import { createElement } from 'react';
import { useUniqueId } from '../uniqueId.js';
import { shape, string, node, oneOfType, element, bool, func } from 'prop-types';
import '../types/props.js';
import 'reakit/styled';
import 'styled-tools';
import 'styled-selector';
import '../styled/selector.js';
import 'lodash/get';
import '../styled/space.js';
import '../styled/index.js';
import { a as _objectSpread, b as _objectWithoutPropertiesLoose, c as _extends } from '../chunk-ad6ad343.js';
import 'polished';
import '../default/palette.js';
import 'reakit/Button';
import 'airbnb-prop-types';
import '../parseIcons.js';
import Box from 'reakit/Box';
import 'reakit/Block';
import 'reakit/Inline';
import 'reakit/InlineBlock';
import 'reakit/Flex';
import 'reakit/InlineFlex';
import 'reakit/Grid';
import '../Icon/styled.js';
import '../chunk-16546651.js';
import '../Set/styled.js';
import '../Set/index.js';
import '../Button/styled.js';
import '../Spinner/styled.js';
import '../Spinner/index.js';
import { b as buttonPropTypes } from '../chunk-68945c57.js';
import _omit from 'lodash/omit';
import ActionButtons, { actionButtonsPropTypes } from '../Button/ActionButtons.js';
import '../Button/index.js';
import 'classnames';
import 'reakit/Heading';
import '../Heading/styled.js';
import '../Heading/index.js';
import '../Pane/styled.js';
import '../chunk-895bf8c9.js';
import '../Pane/index.js';
import '../Icon/index.js';
import '../VisuallyHidden.js';
import './styled.js';
import DialogDialog, { dialogDialogPropTypes, dialogDialogDefaultProps } from './DialogDialog.js';
export { default as DialogDialog, dialogDialogDefaultProps, dialogDialogPropTypes } from './DialogDialog.js';
import DialogContent from './DialogContent.js';
export { default as DialogContent, dialogContentDefaultProps, dialogContentPropTypes } from './DialogContent.js';
import DialogHeader from './DialogHeader.js';
export { default as DialogHeader, dialogHeaderDefaultProps, dialogHeaderPropTypes } from './DialogHeader.js';
import DialogFooter from './DialogFooter.js';
export { default as DialogFooter, dialogFooterDefaultProps, dialogFooterPropTypes } from './DialogFooter.js';
import DialogTitle from './DialogTitle.js';
export { default as DialogTitle, dialogTitleDefaultProps, dialogTitlePropTypes } from './DialogTitle.js';
import DialogClose from './DialogClose.js';
export { default as DialogClose, dialogCloseDefaultProps, dialogClosePropTypes } from './DialogClose.js';
import DialogIcon from './DialogIcon.js';
export { default as DialogIcon, dialogIconDefaultProps, dialogIconPropTypes } from './DialogIcon.js';

var Dialog = function Dialog(_ref) {
  var _a11yDescriptionId = _ref.a11yDescriptionId,
      _a11yTitleId = _ref.a11yTitleId,
      actionButtonsProps = _ref.actionButtonsProps,
      children = _ref.children,
      closeButtonProps = _ref.closeButtonProps,
      footer = _ref.footer,
      hasScroll = _ref.hasScroll,
      onClickClose = _ref.onClickClose,
      showActionButtons = _ref.showActionButtons,
      showCloseButton = _ref.showCloseButton,
      title = _ref.title,
      type = _ref.type,
      props = _objectWithoutPropertiesLoose(_ref, ["a11yDescriptionId", "a11yTitleId", "actionButtonsProps", "children", "closeButtonProps", "footer", "hasScroll", "onClickClose", "showActionButtons", "showCloseButton", "title", "type"]);

  var titleId = useUniqueId('Dialog');
  var descriptionId = useUniqueId('Dialog');
  var a11yDescriptionId = _a11yDescriptionId || descriptionId;
  var a11yTitleId = _a11yTitleId || titleId;
  return createElement(DialogDialog, _extends({
    a11yDescriptionId: a11yDescriptionId,
    a11yTitleId: a11yTitleId
  }, props), title && createElement(DialogHeader, null, typeof title === 'string' ? createElement(DialogTitle, {
    id: a11yTitleId
  }, type && createElement(DialogIcon, {
    a11yHidden: true,
    color: type,
    icon: type
  }), title) : title, showCloseButton && createElement(DialogClose, _extends({
    onClick: onClickClose
  }, closeButtonProps))), createElement(DialogContent, {
    id: a11yDescriptionId,
    hasScroll: hasScroll
  }, children), (footer || showActionButtons) && createElement(DialogFooter, {
    justifyContent: footer ? 'space-between' : 'flex-end'
  }, footer && createElement(Box, null, footer), showActionButtons && createElement(Box, null, createElement(ActionButtons, actionButtonsProps))));
};

Dialog.Dialog = DialogDialog;
Dialog.Header = DialogHeader;
Dialog.Content = DialogContent;
Dialog.Footer = DialogFooter;
Dialog.Title = DialogTitle;
Dialog.Close = DialogClose;
Dialog.Icon = DialogIcon;

var dialogPropTypes = _objectSpread({
  actionButtonsProps: shape(actionButtonsPropTypes),
  a11yDescriptionId: string,
  a11yTitleId: string,
  children: node.isRequired,
  className: string,
  closeButtonProps: shape(_omit(buttonPropTypes, 'children')),
  footer: oneOfType([string, element]),
  hasScroll: bool,
  onClickClose: func,
  showActionButtons: bool,
  showCloseButton: bool,
  title: oneOfType([string, element]),
  type: string
}, dialogDialogPropTypes);

Dialog.propTypes = dialogPropTypes;

var dialogDefaultProps = _objectSpread({}, dialogDialogDefaultProps, {
  actionButtonsProps: {},
  a11yDescriptionId: undefined,
  a11yTitleId: undefined,
  className: undefined,
  closeButtonProps: {},
  footer: undefined,
  hasScroll: false,
  onClickClose: undefined,
  showActionButtons: false,
  showCloseButton: false,
  title: undefined,
  type: undefined
});

Dialog.defaultProps = dialogDefaultProps; // @ts-ignore

var C = Dialog;
export default C;
export { C as Dialog, dialogDefaultProps, dialogPropTypes };